import React, {Component} from 'react'
import { connect } from "react-redux"
import trans from "trans"

import {
    css,
    Select,
    PopupHint,
    Grid,
    GridCell,
    Radio,
    Icon,
    Toggler,
    TextInput,
} from "@bdfx/mergado-ui-kit"

import { updateInputValue as change } from "app/reducers/form"
import { getElementValue, getFormName} from 'shape-edit/forms/helpers'
import { RandomProduct } from 'shape-edit/types'
import { selectFormValues } from 'app/reducers/form'
import { TemplateOrAlternativeTemplateType } from 'template-edit/undoRedoReducers'
import { Project, Template } from 'app/types/model-types'

export interface Props {
    isAlt: boolean
    form: TemplateOrAlternativeTemplateType
    templateForm: Template
    project: Project
    randomProduct: RandomProduct
    change: typeof change
    handleImageRefresh: Function
}

export interface State {

}

class PreferredRandomProduct extends Component<Props, State> {


    render() {
        const { form, project, randomProduct, templateForm } = this.props

        const item_id_element = project?.e_item_id || 'ITEM_ID'
        const item_id = item_id_element ? getElementValue(randomProduct.serialized_data, item_id_element) : null

        const isMatching = templateForm.random_product_id && randomProduct?.id && (
            (`${templateForm.random_product_id}` === `${randomProduct.id}`) ||
            (`${templateForm.random_product_id}` === `${item_id}`)
        )

        return (
            <Grid>
                <GridCell>{trans('preferred_product_preview')}</GridCell>
                <GridCell>
                    <TextInput
                        value={form.random_product_id}
                        placeholder={`${trans('preferred_product_id')} ${trans('or')} ${item_id_element}`}
                        onChange={(evt) => this.props.change('templateForm', 'random_product_id', evt)}
                        onClear={() => this.props.change('templateForm', 'random_product_id', null)}
                        onKeyDown={(e: any) => {
                            if (e.key === 'Enter' && e.target.value && !isMatching) {
                                this.props.handleImageRefresh(templateForm, e.target.value)
                            }
                        }}
                    />
                </GridCell>
            </Grid>
        )
    }
}


function mapStateToProps(state) {
    return {
        isAlt: state.isAlt,
        form: selectFormValues(state, getFormName(state.isAlt)),
        templateForm: selectFormValues(state, 'templateForm'),
        randomProduct: state.randomProduct,
        project: state.project,
    }
}

export default connect(mapStateToProps, {
    change,
})(PreferredRandomProduct)
